<template>
    <li :class="[active]">
        <button @click="$emit('input', id)" class="button">{{ label }}</button>
    </li>
</template>

<script>
export default{
    props:{
        id: Number,
        label: String,
        value: Number
    },
    computed:{
        active(){
            return this.value === this.id ? 'on' : false
        }
    }
}
</script>